import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import {LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import GridDistribDepositoCheques from './form_banco05_gridDistrib';
import styled from 'styled-components';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_PlanillaDepositoCheque, actualizarChequesSeleccionadosEnDistribucion } from '../../actions/bancos/act_banc05';
import { validarCampoString, validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { cargar_CuentasBancarias } from '../../actions/bancos/act_banc01';
import { formatearNumeroDecimal } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

const LabelValor = styled.label`
  display: inline-block;
  font-size: 11px;
  color: green;
  margin-left: 10px;
  font-weight: bold;
  margin-top: 3px;
`;

const ContenedorConMargen = styled.div`
  margin-top: 20px;
`;

class FormBanco05 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {      
      planillaDepositoId: '',
      cheques: [],
      cuentasBancarias: [],
      cuenta_sel: null,      
      nroChequesSel: 0,
      valorTotalChequesSel: 0,
      totalPlanilla: 0,
      totalDistribuido: 0,
      distribucionDepositoCheques: [],
      columnsDefGridCheques: [
        { header: "",
          width: 30,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          pinned: true,
          headerCheckboxSelection: true,  
          headerCheckboxSelectionFilteredOnly: true,
        },        
        { header: "No.",
          field: "Nro",
          width: 30,
          type: "string",
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,   
        },
        {
          header: "F. Vcto. Cheque",
          field: "FechaVctoCheque",
          width: 80,
          type: "string"
        },
        { header: "Cliente",
          field: "Cliente",
          width: 200,
          type: "string"
        },     
        { header: "Banco",
          field: "Banco",
          width: 140,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 90,
          type: "string"
        },
        { header: "Cheque",
          field: "Cheque",
          width: 55,
          type: "string"
        },
        {
          header: "Valor",
          field: "Valor",
          width: 70,
          type: "num_decimal"
        }
      
      ]      
    };
    this.gridChequesOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple',
      singleClickEdit: true,
      suppressRowClickSelection: true,
      onSelectionChanged:  (event)=>{ this.onSelectionChanged() }
    };
    
    this.onGridChequesReady = this.onGridChequesReady.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
    this.getPlanillaDepositoChequeById = this.getPlanillaDepositoChequeById.bind(this);
    this.agregarChequesADistribucion = this.agregarChequesADistribucion.bind(this);
    this.quitarDesdeDistribucion = this.quitarDesdeDistribucion.bind(this);    
    this.quitarChequeDesdeListado = this.quitarChequeDesdeListado.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.guardarDistribucion = this.guardarDistribucion.bind(this);
    this.deshacerDistribucion = this.deshacerDistribucion.bind(this);
    this.generarReporteDistrib = this.generarReporteDistrib.bind(this);
    this.generarReportePlanillaDep = this.generarReportePlanillaDep.bind(this);
  }

  onGridChequesReady(params) {
    this.apiGridCheques = params.api;
    this.columnApiGridCheques = params.columnApi;
  }

  onSelectionChanged(){
    let chequesSeleccionados = this.apiGridCheques.getSelectedRows();
    let valorTotalSeleccionado = 0;

    chequesSeleccionados.forEach(cheque=>{
      valorTotalSeleccionado+=cheque.Valor;
    });

    this.setState({ nroChequesSel: chequesSeleccionados.length,
                    valorTotalChequesSel: valorTotalSeleccionado });

  }

  cambiarValoresInput(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  componentDidMount(){
    Promise.all([
      this.props.generar_LogAuditoriaIngresoForm('0705'),
      this.props.cargar_CuentasBancarias('CC')
    ])
    .then(()=>{
      let cuentasBancarias = this.props.cuentasBancarias;      
      let catalogoCtasBancarias = [];
      cuentasBancarias.forEach(item => {
        catalogoCtasBancarias.push({value: item.Cuenta, label: `${item.Nombre.toString().trim().toUpperCase()} (${item.Numero.toString().trim()})`});
      });
      this.setState({ cuentasBancarias: catalogoCtasBancarias });
    })
    .catch(error => {
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0705');
  }

  limpiar(){
    this.setState({
      planillaDepositoId: '',
      cheques: [],
      distribucionDepositoCheques: [],      
      cuenta_sel: null,
      valorTotalChequesSel: 0,
      nroChequesSel: 0,
      totalPlanilla: 0,
      totalDistribuido: 0
    });
  }
  
  getPlanillaDepositoChequeById(){
    if (!validarCampoString(this.state.planillaDepositoId, 1, 7)){
      alert('No ha especificado correctamente el campo Planilla Depósito Cheque');
      return;
    }

    this.props.cargar_PlanillaDepositoCheque(this.state.planillaDepositoId)
    .then(()=>{
      if(this.props.itemsPlanillaDepCheque.length===0){
        alert('No existe una Planilla Depósito Cheque con el valor especificado o está anulada.');
      }else{
        
        let chequesPendientes = [];
        let chequesDistribuidos = [];
        let totalPlanilla = 0;
        let totalDistribuido = 0;

        this.props.itemsPlanillaDepCheque.forEach((item, i) => {

          totalPlanilla += parseFloat(item.Valor);

          // ItemStatus=I -> Sin distribuir ; ItemStatus=D -> Distribuido

          if (item.ItemStatus === 'I'){
            chequesPendientes.push({
              Nro: chequesPendientes.length+1,
              FechaVctoCheque: item.FechaVctoCheque,
              Cliente: item.Cliente,
              Banco: item.Banco,
              Cuenta: item.Cuenta,
              Cheque: item.Cheque,
              Valor: item.Valor,
              Key: item.Secuencial
            });
          }

          if (item.ItemStatus === 'D'){
            let existeCta = false;
            let indiceExisteCta = 0;
            totalDistribuido += parseFloat(item.Valor);

            for(let i=0; i<chequesDistribuidos.length; i++){              
              if (chequesDistribuidos[i].CodCuentaDepositar === item.CodCtaDepositar){
                existeCta = true;
                indiceExisteCta=i;
                break;
              }
            }            
            
            if (!existeCta){
              chequesDistribuidos.push({
                CodCuentaDepositar: item.CodCtaDepositar,
                DescripCuentaDepositar: item.DescripCtaDepositar,
                Total: 0,
                NroCheques: 0,
                Cheques: []
              })
              indiceExisteCta=chequesDistribuidos.length-1;
            };

            chequesDistribuidos[indiceExisteCta].Cheques.push({
              Nro: chequesDistribuidos[indiceExisteCta].Cheques.length+1,
              FechaVctoCheque: item.FechaVctoCheque,
              Cliente: item.Cliente,
              Banco: item.Banco,
              Cuenta: item.Cuenta,
              Cheque: item.Cheque,
              Valor: item.Valor,
              Key: item.Secuencial
            });

            let totalPorCuentaDepositar = 0;
            let nroCheques = 0;
            chequesDistribuidos[indiceExisteCta].Cheques.forEach(cheque => {
              nroCheques += 1;
              totalPorCuentaDepositar += parseFloat(cheque.Valor);
            });

            chequesDistribuidos[indiceExisteCta].Total = totalPorCuentaDepositar;
            chequesDistribuidos[indiceExisteCta].NroCheques = nroCheques;
          }
        });

        this.setState({cheques: chequesPendientes, distribucionDepositoCheques: chequesDistribuidos, totalPlanilla, totalDistribuido: parseFloat(totalDistribuido)});
      }
    });
  }

  agregarChequesADistribucion(){
    if (this.state.cheques.length===0){
      alert('No existen cheques que se puedan distribuir.');
      return;
    }
    
    let chequesSeleccionados = this.apiGridCheques.getSelectedRows();
      
    if (chequesSeleccionados.length === 0){
      alert('No ha seleccionado los cheques que va a depositar.');
      return;
    }
    if (this.state.cuenta_sel === null){
      alert('No ha seleccionado la cuenta a la cual va a hacer los depósitos.');
      return;
    }

    let cuentaBancaria;
    this.props.cuentasBancarias.forEach(cuenta=> {
      if (cuenta.Cuenta===this.state.cuenta_sel){
        cuentaBancaria = cuenta;
      }
    });

    // Lectura de la distribución de depósito de cheques actual.
    let distribDepositoCheques = [...this.state.distribucionDepositoCheques];
    let existeCta = false;
    let indiceExisteCta = 0;

    // Se verifica si la cuenta a depositar seleccionada ya existe en la distribución actual.
    for(let i=0; i<distribDepositoCheques.length; i++){
      if (distribDepositoCheques[i].CodCuentaDepositar === this.state.cuenta_sel){
        existeCta = true;
        indiceExisteCta=i;
        break;
      }
    }

    let detalleCheques=[];      
    let totalPorCtaDepositar=0;
    let totalChequesSelecc=0;

    // Si la cuenta a depositar no existe en la distribución actual, se ingresa a la distribución.
    if (!existeCta){
      
      chequesSeleccionados.forEach((cheque, i)=>{         
        detalleCheques.push({...cheque, Nro: (i+1)});
        totalChequesSelecc += parseFloat(cheque.Valor);
      });

      totalPorCtaDepositar=totalChequesSelecc;
      
      distribDepositoCheques.push({ CodCuentaDepositar: cuentaBancaria.Cuenta,
                                    DescripCuentaDepositar: cuentaBancaria.Nombre + ' - ' + cuentaBancaria.Numero,
                                    Total: totalPorCtaDepositar,
                                    NroCheques: detalleCheques.length,
                                    Cheques: detalleCheques});
    }else{
      // Si la cuenta a depositar ya existe en la distribución actual solo se añaden los cheques seleccionados.
      detalleCheques = [...distribDepositoCheques[indiceExisteCta].Cheques];
      detalleCheques.forEach(cheque=>{
        totalPorCtaDepositar += parseFloat(cheque.Valor);        
      });

      chequesSeleccionados.forEach((cheque)=>{
        detalleCheques.push({...cheque, Nro: detalleCheques.length+1});
        totalPorCtaDepositar += parseFloat(cheque.Valor);
        totalChequesSelecc += parseFloat(cheque.Valor);
      });

      distribDepositoCheques[indiceExisteCta] = {...distribDepositoCheques[indiceExisteCta], Total: totalPorCtaDepositar,
                                                  NroCheques: detalleCheques.length, Cheques: detalleCheques};
    }
      
    // Asignación de la distribución de cheques a depositar y total distribuido:
    this.setState({distribucionDepositoCheques:distribDepositoCheques, totalDistribuido: parseFloat(this.state.totalDistribuido)+parseFloat(totalChequesSelecc) });
    
    // Eliminar del listado de cheques pendientes de distribuir los cheques seleccionados:
    let chequesPendientes = [...this.state.cheques];
    chequesSeleccionados.forEach(chequeSel => {
      chequesPendientes = this.quitarChequeDesdeListado(chequesPendientes, chequeSel);
    });

    // Asignación de cheques pendientes:
    this.setState({cheques: chequesPendientes,  nroChequesSel: 0, valorTotalChequesSel: 0});
  }

  quitarChequeDesdeListado(listaCheques, chequeAQuitar){
    // Se quita del listado de cheques el cheque especificado.
    // Se asigna el nuevo secuencial a cada cheque de la lista una vez que se haya quitado el cheque especificado.
    let listaResultadoCheques = [];
    listaCheques.filter(item=>item.Key !== chequeAQuitar.Key).forEach(cheque=>{
      listaResultadoCheques.push({...cheque, Nro: listaResultadoCheques.length+1});
    });
    return listaResultadoCheques;
  }
  
  quitarDesdeDistribucion(){
    // Se valida que existan cheques seleccionados para quitar desde la distribución.
    if (this.state.distribucionDepositoCheques.length===0){
      alert('No existen cheques que pueda quitar de la distribución.');
      return;
    }

    if (this.props.chequesDistribSeleccionados.length===0){
      alert('No ha seleccionado los cheques que va a quitar de la distribución.');
      return;
    }
    
    let distribucionDepositoChequesTmp =[];
    let distribucionDepositoCheques = [...this.state.distribucionDepositoCheques];
    let chequesPendientes = [...this.state.cheques];
    let totalChequesSelAQuitar = 0;
    
    this.props.chequesDistribSeleccionados.forEach(item=>{
      
      distribucionDepositoCheques.forEach(itemDistrib=>{

        if (item.CodCuentaDepositar===itemDistrib.CodCuentaDepositar){
        
          let chequesDistribuidosPorCuenta = [...itemDistrib.Cheques];
          item.Cheques.forEach(cheque=>{
            totalChequesSelAQuitar+=parseFloat(cheque.Valor);
            chequesPendientes.push({...cheque, Nro: chequesPendientes.length+1});
            chequesDistribuidosPorCuenta = this.quitarChequeDesdeListado(chequesDistribuidosPorCuenta, cheque);
          });

          let nroCheques = 0;
          let totalPorCtaDepositar = 0;

          if (chequesDistribuidosPorCuenta.length>0){
            chequesDistribuidosPorCuenta.forEach(cheque=>{
              nroCheques += 1;
              totalPorCtaDepositar += parseFloat(cheque.Valor);
            });
            itemDistrib = {...itemDistrib, Total: totalPorCtaDepositar, NroCheques: nroCheques, Cheques: chequesDistribuidosPorCuenta };
            distribucionDepositoChequesTmp.push(itemDistrib);
          }
        }else{
          distribucionDepositoChequesTmp.push(itemDistrib);
        }

      });

      distribucionDepositoCheques = [...distribucionDepositoChequesTmp];
      distribucionDepositoChequesTmp = [];
    });

    this.setState({ distribucionDepositoCheques, cheques: chequesPendientes,
                    totalDistribuido: parseFloat(this.state.totalDistribuido)-parseFloat(totalChequesSelAQuitar)});
    this.props.actualizarChequesSeleccionadosEnDistribucion([]);
  }

  guardarDistribucion(){
    let idPlanillaDep = this.state.planillaDepositoId;

    if (!validarCampoString(idPlanillaDep, 1, 10)){
      alert('No ha seleccionado la Planilla Depósito Cheque que va a distribuir.');
      return;
    }

    if (this.state.distribucionDepositoCheques.length===0){
      alert('No ha realizado la distribución de cheques a las cuentas bancarias que va depositar.');
      return;
    }

    let fechaAsignacion = getFechaProcesoPorModulo('07');    
    if (!validarFechaMomentEnFormatoString(fechaAsignacion)){
      alert('La fecha de la distribución es inválida.');
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);
    global_axios({
      method: 'PUT',
      url: '/distribucionesdepositocheque/' + idPlanillaDep,
      data: { fechaAsignacion,
              usuario: getItemDatosSesion('usuario'), 
              distribucion: this.state.distribucionDepositoCheques}
    })
    .then(response=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert('La distribución se guardó exitosamente.');
      this.limpiar();
    })
    .catch(error=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  deshacerDistribucion(){
    let idPlanillaDep = this.state.planillaDepositoId;

    if (!validarCampoString(idPlanillaDep, 1, 10)){
      alert('No ha seleccionado la Planilla Depósito Cheque de la cual va a deshacer la distribución.');
      return;
    }

    global_axios({
      url: '/distribucionesdepositocheque/' + idPlanillaDep,
      method: 'DELETE'
    })
    .then((response)=>{
      alert('Se deshizo correctamente la distribución de la planilla de depósito : (' + idPlanillaDep + ')');
      this.limpiar();
    })
    .catch((error)=>{
      alert(error.response?error.response.data.msg:error.message);
    });  
  }

  generarReporteDistrib(){
    if (!validarCampoString(this.state.planillaDepositoId, 1, 7)){
      alert('No ha especificado correctamente el campo Planilla Depósito Cheque');
    }

    let idPlanillaDep = this.state.planillaDepositoId;
    visualizarReporteEnPdf('&rpt=10&param1=' + idPlanillaDep);    
  }

  generarReportePlanillaDep(){
    if (!validarCampoString(this.state.planillaDepositoId, 1, 7)){
      alert('No ha especificado correctamente el campo Planilla Depósito Cheque');
    }

    let idPlanillaDep = this.state.planillaDepositoId;
    visualizarReporteEnPdf('&rpt=9&param1=' + idPlanillaDep);    
  }

  render(){
    return(
      <ContenedorForm porc_ancho={95}>
        <HeaderForm>
          <TituloForm>Distribución de cheques a depositar</TituloForm>
        </HeaderForm>
        <CuerpoForm>
          <Row>
            <div className='col-sm-5'>
              <Row>                
                <ContainerCol className='col-sm-5'>
                  <LabelForm>Planilla Depósito Cheque:</LabelForm>
                  <InputSearch tipoInput='text' nombre='planillaDepositoId' placeholder='Plan. Depósito Cheque' valor={this.state.planillaDepositoId} 
                    func_CambiarValor={this.cambiarValoresInput} func_BuscarValor={this.getPlanillaDepositoChequeById} func_OnFocus={()=>{this.limpiar()}}/>
                </ContainerCol>                
                <ContainerCol className='col-sm-4'>
                  <ContenedorConMargen>
                    <LabelForm>Total:</LabelForm>
                    <LabelValor>{formatearNumeroDecimal(this.state.totalPlanilla)}</LabelValor>
                  </ContenedorConMargen>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='390px' data={this.state.cheques} columnas={this.state.columnsDefGridCheques}
                  gridOptions={this.gridChequesOptions} onGridReady={this.onGridChequesReady}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-5'>
                  <LabelForm>Cheques Seleccionados:</LabelForm>
                  <LabelValor className='pull-right'>{this.state.nroChequesSel}</LabelValor>
                </ContainerCol>
                <ContainerCol className='col-sm-7'>
                  <LabelForm >Valor Cheques Seleccionados:</LabelForm>
                  <LabelValor className='pull-right'>{formatearNumeroDecimal(this.state.valorTotalChequesSel)}</LabelValor>
                </ContainerCol>
              </Row>
            </div>
            <div className='col-sm-7'>
              <Row>
                <ContainerCol className='col-sm-5'>
                  <LabelForm>Cuenta a depositar:</LabelForm>
                  <ReactSelect options={ this.state.cuentasBancarias } value={this.state.cuenta_sel} func_onChange={(value)=>{this.setState({cuenta_sel: value===null?null:value.value})}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-7'>
                  <ContenedorConMargen>
                    <LabelForm>Total Distribuido:</LabelForm>
                    <LabelValor>{formatearNumeroDecimal(this.state.totalDistribuido)}</LabelValor>
                  </ContenedorConMargen>
                </ContainerCol>
              </Row>          
              <Row>
                <ContainerCol className='col-sm-12'>
                  <GridDistribDepositoCheques
                    altura='420px'
                    distribucionDepositoCheques={this.state.distribucionDepositoCheques}
                  />
                </ContainerCol>
              </Row>
            </div>
          </Row>
          <Row>
            <div className='col-sm-offset-3 col-sm-2'>
              <button type='button' className='btn btn-primary btn-sm pull-right' onClick={this.agregarChequesADistribucion}>
                Agregar a Distribución <i className='fa fa-caret-right fa-lg'/></button>
            </div>
            <div className='col-sm-7'>
              <button type='button' className='btn btn-primary btn-sm pull-left' onClick={this.quitarDesdeDistribucion}>
              <i className='fa fa-caret-left fa-lg'/> Quitar de Distribución</button>
            </div>
          </Row>
          <Row>            
            <ContenedorConMargen className='col-sm-12'>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarDistribucion}><i className='fa fa-floppy-o fa-lg'/> Guardar Distribución</button>
                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteDistrib}><i className='fa fa-print fa-lg'/> Imprimir Distrib.</button>
                <button type='button' className='btn btn-danger btn-sm' onClick={this.deshacerDistribucion}><i className='fa fa-window-close  fa-lg'/> Deshacer Distribución</button>
                <button type='button' className='btn btn-success btn-sm' onClick={this.generarReportePlanillaDep}><i className='fa fa-print fa-lg'/> Imprimir Plan. Dep.</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
              </div>
            </ContenedorConMargen>
          </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }
  
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,            
            cheques: state.clientes.cheques,
            itemsPlanillaDepCheque: state.bancos.itemsPlanillaDepCheque,
            cuentasBancarias: state.bancos.cuentasBancarias,
            chequesDistribSeleccionados: state.bancos.chequesDistribSeleccionados
  };
};

const mapDispatchToProps = ((dispatch) => {
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                              cargar_PlanillaDepositoCheque, cargar_CuentasBancarias,
                              actualizarChequesSeleccionadosEnDistribucion, cambiar_VisualizacionLoading }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormBanco05);